module.exports = "\n        <div md-dialog-content >{{Message}}..</div>\n        <div md-dialog-actions>\n            <md-progress-bar mode=\"indeterminate\"></md-progress-bar>\n        </div>\n       \n\n    "


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/supplier/loading-dialog.html
// module id = ../../../../../src/app/pages/supplier/loading-dialog.html
// module chunks = 39